<template>
	<a href="/index/chengshixuanze.html" :class="current" :data-scp="scp">
		<i class="icon icon-unfold"></i><span v-text="cityName"></span>
	</a>
</template>
<script>
	export default {
		props: ['current', 'scp']
		, ready: function(){
			this.$set('cityName', this.$root.cityName);
		}
	};
</script>